import React from "react";
import PropTypes from "prop-types";
import styles from "./QuickStartCard.module.css";
import Button from "shared/Button";
import classNames from "classnames";
import { useLocation, Link } from "react-router-dom";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";

/**
 *
 * interactive cards under the quick start section of the home page. Clicking view will link the user to a specific page.
 *
 */
export function QuickStartCard({ title, description, to, src, iconStyles }) {
  const location = useLocation();
  const { path } = useRouteMatch();
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.imageContentRow}>
          <div className={styles.image}>
            <img
              className={classNames(styles.src, iconStyles)}
              src={src}
              alt={title}
            />
          </div>
          <div className={styles.body}>
            <div className={styles.title}>{title}</div>
            <div className={styles.description}>{description}</div>
          </div>
        </div>
        <div className={styles.btn}>
          <Link to={`/dreamstream${to}`}>
            <Button
              className={styles.customBtn}
              size={"small"}
              children={"VIEW"}
            />
          </Link>
        </div>
      </div>
    </div>
  );
}

QuickStartCard.propTypes = {
  /**
   * Title of the page the card links to .
   */
  title: PropTypes.string,
  /**
   * Description of the page underneath the title .
   */
  description: PropTypes.string,
  /**
   * Function called when the user clicks the view btn.
   */
  onClick: PropTypes.func,
  /**
   * Src for the image on the left of the card .
   */
  src: PropTypes.string,
  /**
   * Styles for the icon.
   */
  iconStyles: PropTypes.string,
};
